import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {resolveIsShowcase} from '../shared/tokens/is-showcase.factory';

/** Зарезервированные первые сегменты пути, которые не являются hash-ами витрин. */
const RESERVED_ROOT_SEGMENTS = new Set(['404']);

@Injectable({providedIn: 'root'})
export class ShowcaseContextService {
  readonly hash: string | null = ShowcaseContextService.readHash();

  static readHash(): string | null {
    if (typeof window === 'undefined') return null;
    if (!resolveIsShowcase(window.location.host, environment.showcaseUrl)) {
      return null;
    }
    const segments = window.location.pathname.split('/').filter(Boolean);
    const first = segments[0];
    if (!first || RESERVED_ROOT_SEGMENTS.has(first)) {
      return null;
    }
    return first;
  }
}
